// Helper function to scroll to an element
function scrollToElement(element) {
    if (!element) {
        return;
    }

    const elementTop = element.offsetTop;
    window.scrollTo({
        top: elementTop,
        behavior: 'smooth'
    });
}

// Load more product reviews
document.addEventListener('click', function(event) {
    const target = event.target.closest('[data-product-review-load]');
    if (!target) {
        return;
    }

    event.preventDefault();

    const container = target.closest('[data-product-review-container]');
    if (!container) {
        return;
    }

    const sku = container.getAttribute('data-product-review-sku');
    const currentPage = parseInt(container.getAttribute('data-product-review-current-page'), 10);
    const totalPages = parseInt(container.getAttribute('data-product-review-total-pages'), 10);
    const reviewUri = '/ajax/review.json';
    const loadingDataClass = 'product-review-loading';

    if (container.classList.contains(loadingDataClass) || currentPage >= totalPages) {
        return;
    }

    container.classList.add(loadingDataClass);

    const params = new URLSearchParams({
        sku: sku,
        page: currentPage + 1
    });

    fetch(reviewUri + '?' + params.toString(), {
        method: 'GET',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json'
        }
    })
        .then(response => response.json())
        .then((data) => {
            if (data.success) {
                const reviewsContainer = container.querySelector('[data-product-review-reviews]');
                if (reviewsContainer) {
                    reviewsContainer.insertAdjacentHTML('beforeend', data.html);
                }

                container.setAttribute('data-product-review-current-page', data.currentPage);
                container.setAttribute('data-product-review-total-pages', data.totalPages);

                if (data.currentPage >= data.totalPages) {
                    const loadButton = container.querySelector('[data-product-review-load]');
                    if (loadButton) {
                        loadButton.remove();
                    }
                }
            }
        })
        .catch((error) => {
            // eslint-disable-next-line no-console
            console.error('Error loading reviews:', error);
        })
        .finally(() => {
            container.classList.remove(loadingDataClass);
        });
});

// Show full review content
document.addEventListener('click', function(event) {
    const target = event.target.closest('[data-full-review-content] a');
    if (!target) {
        return;
    }

    event.preventDefault();
    const contentContainer = target.closest('[data-full-review-content]');
    if (contentContainer) {
        const fullContent = contentContainer.getAttribute('data-full-review-content');
        if (fullContent) {
            contentContainer.innerHTML = fullContent;
        }
    }
});

// Scroll to reviews section
document.addEventListener('click', function(event) {
    const target = event.target.closest('[data-scroll-to-reviews]');
    if (!target) {
        return;
    }

    event.preventDefault();
    const reviewsElement = document.querySelector('[data-product-full-reviews]');
    scrollToElement(reviewsElement);
});

// Scroll to content section
document.addEventListener('click', function(event) {
    const target = event.target.closest('[data-scroll-to-content]');
    if (!target) {
        return;
    }

    event.preventDefault();
    const contentElement = document.querySelector('[data-product-page-cms-content]');
    scrollToElement(contentElement);
});
